import angular from 'angular';
import { slugifyModule } from '../../services/filters/slugify/slugify.module';
import { actionButtonModule } from '../ActionButton/ActionButton.module';
import { HorizontalRowController } from './HorizontalRow.controller';
import template from './HorizontalRow.template.html';
import './HorizontalRow.scss';

export const horizontalRowModule = angular
  .module('bit.components.HorizontalRow', [
    slugifyModule.name,
    actionButtonModule.name,
  ])
  .component('bitHr', {
    bindings: {
      event: '<',
    },
    template,
    controller: HorizontalRowController,
  });
